export var ClientCommand;

(function (ClientCommand) {
  ClientCommand["pushUrl"] = "pushUrl";
  ClientCommand["scrollTo"] = "scrollTo";
  ClientCommand["replaceUrl"] = "replaceUrl";
  ClientCommand["getPageInfo"] = "getPageInfo";
  ClientCommand["resizeWindow"] = "resizeWindow";
  ClientCommand["getAccessToken"] = "getAccessToken";
  ClientCommand["requestUserFeedback"] = "requestUserFeedback";
  ClientCommand["requestInAppPurchase"] = "requestInAppPurchase";
  ClientCommand["requestMainProductPurchase"] = "requestMainProductPurchase";
  ClientCommand["requestEmailSubscriptionChange"] = "requestEmailSubscriptionChange";
})(ClientCommand || (ClientCommand = {}));